import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = {
  class: "relative flex flex-col",
  style: {"height":"100%"}
}
const _hoisted_2 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400 z-20 relative" }
const _hoisted_3 = { class: "flex flex-row my-4" }
const _hoisted_4 = { class: "font-semibold text-20px mr-4 text-black-lp-200 title-layout" }
const _hoisted_5 = { class: "hidden" }
const _hoisted_6 = {
  class: "w-full pt-6 overflow-y-auto",
  style: {"height":"100%"}
}
const _hoisted_7 = { class: "flex flex-row gap-x-4" }
const _hoisted_8 = { class: "flex flex-col w-full" }
const _hoisted_9 = { class: "flex flex-row mt-2" }
const _hoisted_10 = {
  key: 0,
  class: "flex flex-col gap-y-3"
}
const _hoisted_11 = {
  key: 0,
  class: "rounded-r-lg border-r border-pink-lp-300 rounded-l-lg border-l border-t border-b w-full sm:w-300px px-4 py-3 info relative overflow-hidden"
}
const _hoisted_12 = { class: "flex justify-between items-center text-red-lp-100" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "z-10 relative cursor-default font-bold text-12px xxl:text-14px" }, "Sudah dibooking", -1)
const _hoisted_14 = { class: "z-10 relative cursor-default font-semibold text-20px xxl:text-22px" }
const _hoisted_15 = { class: "space-y-2 px-2 pb-4" }
const _hoisted_16 = { class: "flex flex-col" }
const _hoisted_17 = {
  key: 0,
  class: "w-full flex flex-col border-t border-gray-lp-400 pt-8"
}
const _hoisted_18 = {
  key: 1,
  class: "w-full"
}
const _hoisted_19 = { class: "mt-12 md:mt-8" }
const _hoisted_20 = /*#__PURE__*/_createVNode("h2", { class: "text-14px pt-5 text-black-lp-300 font-bold" }, " Total Pembayaran ", -1)
const _hoisted_21 = { class: "flex items-center justify-center py-3" }
const _hoisted_22 = { class: "text-gray-lp-600 line-through text-14px mr-3" }
const _hoisted_23 = { class: "text-red-lp-100 font-bold text-18px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_data_wrapper = _resolveComponent("data-wrapper")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Select = _resolveComponent("Select")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_custom_dropdown = _resolveComponent("custom-dropdown")!
  const _component_advanced_filter = _resolveComponent("advanced-filter")!
  const _component_skeleton = _resolveComponent("skeleton")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ModalDetailShipment = _resolveComponent("ModalDetailShipment")!
  const _component_ModalAddShipmentDestination = _resolveComponent("ModalAddShipmentDestination")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_card = _resolveComponent("card")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("img", {
            src: _imports_0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
            class: "w-5 mr-3 cursor-pointer",
            alt: "arrow-left"
          }),
          _createVNode("div", _hoisted_4, _toDisplayString(_ctx.getTitle), 1)
        ])
      ]),
      _withDirectives(_createVNode("div", _hoisted_5, null, 512), [
        [_directive_click_outside, () => (_ctx.chevronUp = _ctx.chevronUp.map(() => false))]
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_Card, {
              rounded: "xl",
              class: "w-3/4 flex flex-col p-5",
              isShadow: false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_data_wrapper, { label: "Shipment ID/scan barcode" }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_9, [
                      _withDirectives(_createVNode("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.shipmentId = $event)),
                        onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.parseInputShipmentId && _ctx.parseInputShipmentId(...args))),
                        type: "text",
                        onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.fetchShipmentId('inputShipmentId')), ["enter"])),
                        placeholder: "Contoh : B12356KHJZS",
                        class: "input-with-icon flex-grow mr-4 py-2.5 xxl:py-3 px-3 rounded-r-md border-r rounded-l-md border-l border-t border-b false focus:outline-none focus:shadow text-black-lp-300"
                      }, null, 544), [
                        [_vModelText, _ctx.shipmentId]
                      ]),
                      _createVNode(_component_lp_button, {
                        class: 
                    `px-5 rounded-md icon-white button-style flex flex-row justify-center align-middle ${
                      !_ctx.shipmentId ? `color-disabeled` : `bg-red-lp-100`
                    }`
                  ,
                        "text-color": "white",
                        title: "Tambah",
                        flat: "",
                        onClick: _cache[5] || (_cache[5] = 
                    () =>
                      _ctx.shipmentId ? _ctx.fetchShipmentId('inputShipmentId') : null
                  )
                      }, null, 8, ["class"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.showAddDestination)
              ? (_openBlock(), _createBlock(_component_lp_button, {
                  key: 0,
                  class: "pt-8 mr-2 add-destination",
                  title: "Tambah Alamat Tujuan",
                  "text-color": _ctx.enableAddDestination ? `red-lp-100` : `gray-500`,
                  color: _ctx.enableAddDestination ? `red-lp-100` : `gray-500`,
                  outline: "",
                  disabled: !_ctx.enableAddDestination,
                  onClick: _cache[6] || (_cache[6] = () => (_ctx.enableAddDestination ? _ctx.onAddDestination() : null))
                }, null, 8, ["text-color", "color", "disabled"]))
              : _createCommentVNode("", true)
          ]),
          ((_ctx.shipmentIdList.length > 0 && !_ctx.isLoading) || _ctx.isSetFilter)
            ? (_openBlock(), _createBlock("div", _hoisted_10, [
                (_ctx.shipmentIdList.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_11, [
                      _createVNode("img", {
                        class: "absolute w-full",
                        style: {"left":"0px","top":"0px","bottom":"0px","right":"0px"},
                        src: require('@/app/ui/assets/svg/bg-shipment-booked.svg'),
                        alt: "info"
                      }, null, 8, ["src"]),
                      _createVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _createVNode("span", _hoisted_14, _toDisplayString(_ctx.bookedCount) + "/" + _toDisplayString(_ctx.shipmentIdList.length), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_advanced_filter, {
                  "custom-max-height": "42vh",
                  customWidth: "w-full",
                  addSumFilter: _ctx.sumFilter,
                  onReset: _ctx.onResetAdvancedFilter,
                  title: "Urutkan"
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_15, [
                      _createVNode(_component_DataWrapper, { label: "Status Booking" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Select, {
                            dataSelect: _ctx.orderByData,
                            onOpenSelect: _ctx.onOpenOrderBy,
                            onCloseSelect: _ctx.onCloseOrderBy,
                            onChooseSelect: _ctx.onSelectOrderBy,
                            value: _ctx.orderByTitle,
                            isOpenMenu: _ctx.orderBySelect,
                            isDefaultBlack: true,
                            class: "w-full z-10"
                          }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_DataWrapper, { label: "Urutkan" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_custom_dropdown, {
                            placeholder: "Urutkan",
                            value: "Urutkan",
                            class: "w-full",
                            isExpand: _ctx.isExpand,
                            "onUpdate:isExpand": _cache[7] || (_cache[7] = ($event: any) => (_ctx.isExpand = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode("div", _hoisted_16, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortOptions, (item, index) => {
                                  return (_openBlock(), _createBlock("label", {
                                    class: ["py-1 hover:text-red-lp-100 cursor-pointer", item === _ctx.sortBy && `text-red-lp-100`],
                                    key: index.toString(),
                                    onClick: () => _ctx.setSortBy(item)
                                  }, _toDisplayString(item), 11, ["onClick"]))
                                }), 128))
                              ])
                            ]),
                            _: 1
                          }, 8, ["isExpand"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["addSumFilter", "onReset"])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock("div", _hoisted_17, [
              _createVNode(_component_skeleton, {
                width: "600px",
                height: "40px"
              }),
              _createVNode(_component_skeleton, {
                class: "mt-10",
                width: "800px",
                height: "40px"
              }),
              _createVNode(_component_skeleton, {
                class: "mt-3",
                width: "700px",
                height: "20px"
              }),
              _createVNode(_component_skeleton, {
                class: "mt-3",
                width: "500px",
                height: "20px"
              }),
              _createVNode(_component_skeleton, {
                class: "mt-3",
                width: "800px",
                height: "20px"
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.shipmentIdList.length > 0 && !_ctx.isLoading)
          ? (_openBlock(), _createBlock("div", _hoisted_18, [
              _createVNode("div", _hoisted_19, [
                _createVNode(_component_TableV2, {
                  columns: _ctx.columns,
                  data: _ctx.shipmentIdList,
                  loading: _ctx.isLoading,
                  pagination: _ctx.pagination,
                  "pagination-style": "v2",
                  "is-hard-pagination": true,
                  totalColumnFreeze: 1,
                  bgHeader: 'bg-white border-b border-gray-300',
                  isPinnedScrollBottom: "",
                  pinnedSubstractHeight: "400px",
                  isNoPaddingBottom: ""
                }, null, 8, ["columns", "data", "loading", "pagination"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.isError)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 0,
          errorType: _ctx.errorCause,
          onCancel: _ctx.handleError,
          onTryAgain: _ctx.fetchShipmentId('inputShipmentId'),
          modal: ""
        }, null, 8, ["errorType", "onCancel", "onTryAgain"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: "Yakin ingin keluar?",
      message: "Perubahan data booking tidak akan tersimpan.",
      image: "badge-warning-lg",
      textSuccess: "Keluar",
      textCancel: "Tetap disini",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    (_ctx.showModalShipment)
      ? (_openBlock(), _createBlock(_component_ModalDetailShipment, {
          key: 1,
          onUpdateStatus: _ctx.initPage,
          shipmentIdList: _ctx.shipmentList
        }, null, 8, ["onUpdateStatus", "shipmentIdList"]))
      : _createCommentVNode("", true),
    (_ctx.bookingAddShipmentDestination)
      ? (_openBlock(), _createBlock(_component_ModalAddShipmentDestination, {
          key: 2,
          shipmentId: _ctx.shipmentId,
          source: _ctx.shipmentIdList[0]?.customerName,
          onSuccessBooking: _ctx.fetchShipmentId
        }, null, 8, ["shipmentId", "source", "onSuccessBooking"]))
      : _createCommentVNode("", true),
    (_ctx.shipmentIdList.length === 0 && !_ctx.isLoading && _ctx.isGenerate)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 3,
          errorType: "notfound"
        }))
      : _createCommentVNode("", true),
    (_ctx.shipmentIdList.length === 0 && !_ctx.isLoading && !_ctx.isGenerate)
      ? (_openBlock(), _createBlock(_component_EmptyState, {
          key: 4,
          icon: "noData_empty",
          customHeaderMessage: "Belum ada data shipment ID",
          customMessage: "Tambahkan shipment ID atau scan barcode terlebih dahulu."
        }))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseSuccess,
      title: "Pembuatan Booking Baru Berhasil !",
      message: `${this.messageSuccess}`,
      image: "image-modal-success",
      textSuccess: "OK",
      class: "px-8"
    }, {
      custom: _withCtx(() => [
        (_ctx.discount?.isDiscount)
          ? (_openBlock(), _createBlock(_component_card, {
              key: 0,
              isShadow: false,
              class: "mt-3"
            }, {
              default: _withCtx(() => [
                _hoisted_20,
                _createVNode("div", _hoisted_21, [
                  _createVNode("div", _hoisted_22, _toDisplayString(_ctx.formatPrice(_ctx.discount.totalTariff)), 1),
                  _createVNode("div", _hoisted_23, _toDisplayString(_ctx.formatPrice(_ctx.discount.totalAfterDiscount)), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.openSuccess]
    ])
  ], 64))
}